module.exports = __webpack_public_path__ + "img/5-2.2343d440.png";